import { Affix } from 'antd';
export default Affix;
